export default __webpack_public_path__ + "static/media/drum_three.55be43e6.mp3";